import { createAction } from '@reduxjs/toolkit';

import { ModuleSummary } from '@savgroup-front-common/types';
import { QuoteClientAnswer } from '@savgroup-front-common/types/Quotation/QuoteClientAnswer';

import * as FileTrackingActionTypes from './actionTypes';
import { REHYDRATE_FILE_TRACKING_PAGE } from './actionTypes';

export const approveOrRejectQuote = createAction<{
  answer: QuoteClientAnswer;
  targetStateName: string;
  fileId: string;
  comment?: string;
  quoteId?: string;
  fromState: string;
  module: ModuleSummary;
}>(FileTrackingActionTypes.APPROVE_REJECT_QUOTE.BASE);
export const loadFileTrackingItemData = createAction<{
  fileId: string;
}>(FileTrackingActionTypes.LOAD_CURRENT_FILE_TRACKING_ITEM_DATA.BASE);
export const submitAdditionalInfo = createAction<{
  module: ModuleSummary;
  fileId: string;
  fromState: string;
  toState: string;
  comment?: string;
}>(FileTrackingActionTypes.SUBMIT_ADDITIONAL_INFO.BASE);

export const rehydrateFileTrackingPage = createAction<{
  fileId: string;
}>(REHYDRATE_FILE_TRACKING_PAGE.BASE);
